'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { BaseAnchor } from '@qogita/ui/v2/base-anchor'
import { usePathname, useSearchParams } from 'next/navigation'
import { ComponentProps, Suspense } from 'react'
import {
  currentPageRedirectTo,
  loginRedirectPathname,
  serializeLoginLink,
} from 'src/app/login/_lib/search-params'

/**
 * Link to the login page that will redirect back to the current page after login.
 *
 * The header is shared across routes, so the current query string is copied
 * as-is. `redirectTo` is written with the login page nuqs serializer.
 */
export function LoginLink(
  props: Omit<ComponentProps<typeof BaseAnchor>, 'href'>,
) {
  const pathname = loginRedirectPathname(usePathname())
  const searchParams = useSearchParams()

  return (
    <Suspense fallback={<BaseLoginLink {...props} />}>
      <BaseAnchor
        href={serializeLoginLink('/login', {
          redirectTo: currentPageRedirectTo(pathname, searchParams),
        })}
        {...props}
      />
    </Suspense>
  )
}

/**
 * A link to the login page without redirect parameters.
 *
 * Can be used as a suspense fallback since it doesn't read the current pathname or search params.
 */
function BaseLoginLink(props: Omit<ComponentProps<typeof BaseAnchor>, 'href'>) {
  return <BaseAnchor href="/login" {...props} />
}
